const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

const POSTCODE_INFO_TEXT =
    'We use your postcode to help us offer you a more personalised experience, ensuring that you only see ads based on your location.';
const DOB_INFO_TEXT =
    'We will use your date of birth to allow us to serve age-appropriate content and offer you a more personalised experience with more relevant ads and content recommendations.';

const DISCLOSURE_TITLE = 'Why we need to collect your data';
const GENDER_INFO_TEXT =
    'We use your gender to help us offer you a more personalised experience with more relevant ads and content recommendations. If you\'d rather not share it, select "Prefer not to say".';

// MD-4154: order is the spec's order and is asserted by the tests — do not sort.
const DATA_DISCLOSURES = [
    { heading: 'Postcode', text: POSTCODE_INFO_TEXT },
    { heading: 'Date of birth', text: DOB_INFO_TEXT },
    { heading: 'Gender', text: GENDER_INFO_TEXT },
];

// MD-4156: order is the spec's order and is asserted by the tests — do not sort.
const GENDER_OPTIONS = ['Female', 'Male', 'Non-binary', 'Prefer not to say'];

const PIN_TEXT_NEW_ACCOUNT = 'Thank you, your account has been created. Please provide the code shown on your TV.';
const PIN_TEXT_EXISTING_ACCOUNT = 'Please provide the code shown on your TV.';

const PIN_ERROR_UNAUTHORIZED = 'Your authentication is invalid. Please sign in again.';
const PIN_ERROR_INVALID = 'Your PIN code is invalid. Please try again with a valid PIN code.';

const USER_ERROR_INCORRECT = 'Incorrect email or password.';
const USER_ERROR_EXISTS = 'There is already an account with that email address.';

const INVALID_EMAIL_ERROR = 'Invalid email address. User not found.';

enum Screens {
    SIGNIN = 'signin',
    REGISTER = 'register',
    FORGOT_PASSWORD = 'forgot_password',
    SOCIAL_LOGIN = 'social_login',
    CHANGE_PASSWORD = 'change_password',
    PIN_SCREEN = 'pin_screen',
    RESULT_SCREEN = 'result_screen',
    MY_DATA = 'my_data'
};

enum PinResult {
    OK = 'OK',
    UNAUTHORIZED = 'UNAUTHORIZED',
    INVALID_PIN = 'INVALID_PIN'
};

enum CookiesOptions {
    COOKIES = 'cookies',
    REGISTRATION = 'registration',
};

enum SocialProvider {
    FACEBOOK = 'facebook',
    TWITTER = 'twitter',
    GOOGLE = 'google',
};

export { 
    monthNames, 
    Screens, 
    PinResult, 
    CookiesOptions,
    SocialProvider,
    DISCLOSURE_TITLE,
    DATA_DISCLOSURES,
    GENDER_OPTIONS,
    PIN_TEXT_NEW_ACCOUNT,
    PIN_TEXT_EXISTING_ACCOUNT,
    PIN_ERROR_UNAUTHORIZED,
    PIN_ERROR_INVALID,
    USER_ERROR_INCORRECT,
    USER_ERROR_EXISTS,
    INVALID_EMAIL_ERROR
};
